import { render } from "./LineChart.vue?vue&type=template&id=4f044364&bindings={\"id\":\"props\",\"label\":\"props\",\"url\":\"props\"}"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"
script.render = render

export default script